<template>
  <!-- 本文件是用来替代修改./index.vue文件，所修改的扩展教练员增加组件（允许教练员添加多个球队） -->
  <el-dialog
    :visible.sync="isShow"
    width="600px"
    top="9vh"
    :title="isEdit ? '编辑球员' : '添加球员'"
    :close-on-click-modal="false"
    custom-class="yioks_alert"
  >
    <el-form
      ref="playerInfo"
      :model="playerInfo"
      :rules="formRules"
      label-width="120px"
      class="demo-ruleForm"
    >
      <vue-scroll :ops="ops">
        <div
          class="player-list-wrapper"
          v-for="(playerItem, index) in playerInfo.playerToSquads"
          :key="index"
        >
          <!-- 登录角色可编辑内容； 注意system admin用户，可以全部编辑，但是此外的用户不允许编辑全部球队 -->
          <template v-if="!playerItem.canEdit">
            <div class="left-box">
              <!-- 管理员 -->
              <template v-if="userRole !== 'coach'">
                <el-row>
                  <el-col :span="20">
                    <el-form-item
                      label="管理单位"
                      :prop="`playerToSquads.${index}.organUuid`"
                      :rules="[requiredItem('管理单位')]"
                    >
                      <el-select
                        v-model.trim="playerItem.organUuid"
                        style="width: 100%"
                        placeholder="请选择管理单位"
                        @change="changeOrg(playerItem.organUuid, index)"
                      >
                        <el-option
                          v-for="item in organList"
                          :key="item.organUuid"
                          :value="item.organUuid"
                          :label="item.organShortName"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item
                      label="单位"
                      :prop="`playerToSquads.${index}.youthUuid`"
                      :rules="[requiredItem('单位')]"
                    >
                      <el-select
                        v-model.trim="playerItem.youthUuid"
                        style="width: 100%"
                        placeholder="请选择管理单位后再选择单位"
                        @change="changeCenter(playerItem.youthUuid, index)"
                      >
                        <el-option
                          v-for="item in centerList[index]"
                          :key="item.uuid"
                          :value="item.uuid"
                          :label="item.youthShortName"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item
                      label="选择球队"
                      :prop="`playerToSquads.${index}.squadUuid`"
                    >
                      <el-select
                        v-model.trim="playerItem.squadUuid"
                        style="width: 100%"
                        no-data-text="暂时没有球队，请前往球队管理添加球队"
                        :placeholder="$t('teamPlaceholder')"
                        @change="changeSquad(playerItem.squadUuid, index)"
                      >
                        <el-option
                          v-for="(item, index) in squadList[index]"
                          :key="index"
                          :label="item.shortName"
                          :value="item.uuid"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>
              <template v-else>
                <el-row>
                  <el-col :span="20">
                    <el-form-item
                      label="选择球队"
                      :prop="`playerToSquads.${index}.squadUuidForCoach`"
                      :rules="[requiredItem('球队', true)]"
                    >
                      <el-select
                        v-model.trim="playerItem.squadUuidForCoach"
                        style="width: 100%"
                        no-data-text="暂时没有球队，请前往球队管理添加球队"
                        :placeholder="$t('teamPlaceholder')"
                        @change="
                          changeSquadForCoach(
                            playerItem.squadUuidForCoach,
                            index
                          )
                        "
                      >
                        <el-option
                          v-for="item in selectsquadList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.key"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>
              <el-row>
                <el-col :span="20">
                  <el-form-item
                    label="位置"
                    :prop="`playerToSquads.${index}.position`"
                    :rules="playerItem | filterForRules"
                  >
                    <!-- playerItem.squadUuidForCoach ? [requiredItem('位置')] : [] -->
                    <el-select
                      v-model.trim="playerItem.position"
                      multiple
                      style="width: 100%"
                      :placeholder="$t('positionPlaceholder')"
                      @change="changePosition(playerItem.position, index)"
                    >
                      <el-option
                        v-for="(item, index) in playerOption"
                        :key="index"
                        :label="item.playerPositionName"
                        :value="item.playerPositionName"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="20">
                  <el-form-item
                    label="球衣号码"
                    :prop="`playerToSquads.${index}.playerNumber`"
                    :rules="playerNumberRule"
                  >
                    <el-input
                      v-model.number="playerItem.playerNumber"
                      placeholder="请输入球衣号码"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="right-box">
              <div
                v-if="!(playerInfo.playerToSquads.length === 1 && index == 0)"
              >
                <el-button
                  type="danger"
                  icon="el-icon-remove-outline"
                  circle
                  @click="handleDeletePlayerList(index)"
                ></el-button>
              </div>
              <div style="margin-top: 10px">
                <el-button
                  type="success"
                  icon="el-icon-circle-plus-outline"
                  circle
                  @click="handleAddPlayerList"
                ></el-button>
              </div>
            </div>
          </template>
          <template v-else>
            <template v-if="userRole !== 'coach'">
              <!-- 非系统管理员且非教练账户 不可编辑球队信息 -->
              <div class="left-box">
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="管理单位">
                      <el-input
                        v-model="playerItem.organShortName"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="单位">
                      <el-input
                        v-model="playerItem.youthShortName"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="选择球队">
                      <el-input
                        v-model="playerItem.shortName"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="位置">
                      <!-- :prop="`playerToSquads.${index}.position`" :rules="[requiredItem('位置')]" -->
                      <el-select
                        v-model.trim="playerItem.position"
                        multiple
                        style="width: 100%"
                        disabled
                        :placeholder="$t('positionPlaceholder')"
                      >
                        <el-option
                          v-for="(item, index) in playerOption"
                          :key="index"
                          :label="item.playerPositionName"
                          :value="item.playerPositionName"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="20">
                    <el-form-item
                      label="球衣号码"
                      :prop="`playerToSquads.${index}.playerNumber`"
                      :rules="playerNumberRule"
                    >
                      <el-input
                        v-model.number="playerItem.playerNumber"
                        disabled
                        placeholder="请输入球衣号码"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </template>
            <template v-else>
              <!-- 教练员帐号 不可编辑球队信息 -->
              <div class="left-box">
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="选择球队">
                      <el-input
                        v-model="playerItem.squadUuidForCoachShow"
                        disabled
                        placeholder="请选择球队信息"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="位置">
                      <!-- :prop="`playerToSquads.${index}.position`" :rules="[requiredItem('位置')]" -->
                      <el-select
                        v-model.trim="playerItem.position"
                        multiple
                        style="width: 100%"
                        :placeholder="$t('positionPlaceholder')"
                        disabled
                      >
                        <el-option
                          v-for="(item, index) in playerOption"
                          :key="index"
                          :label="item.playerPositionName"
                          :value="item.playerPositionName"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item
                      label="球衣号码"
                      :prop="`playerToSquads.${index}.playerNumber`"
                      :rules="playerNumberRule"
                    >
                      <el-input
                        v-model.number="playerItem.playerNumber"
                        disabled
                        placeholder="请输入球衣号码"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </template>
          </template>
        </div>

        <el-row>
          <el-col :span="20">
            <el-form-item label="姓名" prop="idName">
              <el-input
                v-model.trim="playerInfo.idName"
                placeholder="请输入球员姓名"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="20">
            <el-form-item label="证件类型" prop="idType">
              <el-select
                v-model="playerInfo.idType"
                placeholder="请选择证件类型"
                style="width: 100%"
                :disabled="isEdit ? true : false"
                @change="changeType(playerInfo.idType)"
              >
                <el-option
                  v-for="(item, index) in id_types"
                  :key="index"
                  :label="item.key"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item
                label="颁发国家/地区"
                class="form_item"
                prop="idCountry"
                v-if="this.playerInfo.idType === 'PASSPORT'"
              >
                <el-select
                  v-model="playerInfo.idCountry"
                  placeholder="请选择国家/地区"
                  style="width: 100%"
                  filterable
                  :disabled="isEdit ? true : false"
                >
                  <el-option
                    v-for="item in allCountry"
                    :key="item.country_code"
                    :label="item.country_zh"
                    :value="item.country_code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="颁发国家/地区"
                class="form_item"
                prop="idCountry"
                v-if="
                  this.playerInfo.idType !== 'PASSPORT' &&
                  this.playerInfo.idType !== ''
                "
              >
                <el-select
                  v-model="playerInfo.idCountry"
                  style="width: 100%"
                  :disabled="isEdit ? true : false"
                >
                  <el-option key="CN" label="中国" value="CN"></el-option>
                </el-select>
              </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="20">
            <el-form-item label="身份证号" prop="idNumber">
              <el-input
                v-model.trim="playerInfo.idNumber"
                :disabled="isEdit ? true : false"
                :placeholder="id_numberMsg"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="playerInfo.idType !== 'IDNUMBER'">
          <el-col :span="20">
            <el-form-item label="出生年月" prop="birthday">
              <el-date-picker
                v-model="playerInfo.birthday"
                type="month"
                value-format="timestamp"
                placeholder="请选择出生年月">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="playerInfo.idType !== 'IDNUMBER'">
          <el-col :span="20">
            <el-form-item label="性别" prop="gender">
              <el-select v-model="playerInfo.gender" placeholder="请选择性别">
                <el-option value="男" label="男"></el-option>
                <el-option value="女" label="女"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!--<el-row>-->
        <!--<el-col :span="20">-->
        <!--<el-form-item label="手机号码" prop="phone">-->
        <!--<el-input v-model.trim="playerInfo.phone" placeholder="请输入球员手机号码"></el-input>-->
        <!--</el-form-item>-->
        <!--</el-col>-->
        <!--</el-row>-->

        <el-form-item label="上传照片">
          <UploadImg
            :imgUrl.sync="playerInfo.headImgUrl"
            :avatarUrl.sync="img"
          />
          <div>支持jpg,jpeg,bmp,gif,png格式上传</div>
        </el-form-item>
      </vue-scroll>
    </el-form>
    <!--<div v-if="!isEdit" class="tip">* 该手机号将作为球员的初始密码，身份证号作为登录帐号</div>-->
    <div class="dialog_btn_wrap">
      <el-button
        type="primary"
        :loading="addBtnLoading"
        @click="addPlayerAccount"
        >确定</el-button
      >
      <el-button type="danger" style="margin-left: 20px" @click="isShow = false"
        >取消</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { centerStatusList, id_types } from "@/utils/yioks_data";
import player from "@/api/player";
import squad from "@/api/squad";
import rulesMixin from "@/utils/formRules/player";
import rules from "@/utils/formRules/rules";
import person from "@/assets/images/common/person.jpg";
import storage from "@/utils/storage";
import { ops } from "@/utils/scrollIndialog";
// import { JSEncrypt } from 'jsencrypt'
import JSEncrypt from "@/assets/js/jsencrypt.min.js";
import auth from "@/api/auth";
import { requiredItem } from "@/assets/js/formRules";
  import {countryArr} from "@/utils/country";

export default {
  name: "index",
  components: {
    UploadImg: () => import("@/components/UploadImg"),
  },
  mixins: [rulesMixin],
  props: {
    addPlayer: {
      type: Boolean,
      required: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    player: {
      type: Object,
      required: false,
    },
    defaultSelect: {
      type: Object,
      required: false,
    },
  },
  data() {
    const playerNumberRule = [
      {
        required: false,
        validator: (rule, value, callback) => {
          if (!value) {
            callback();
          } else {
            if (rules.playerNumber(value)) {
              callback();
            } else {
              callback(new Error("请输入0-99内的球衣号码"));
            }
          }
        },
        trigger: "blur",
      },
    ];

    return {
      id_types,
      playerNumberRule,
      ops,
      person,
      img: "",
      requiredItem,
      allCountry:countryArr.slice(1),
      playerInfo: {
        organUuid: "",
        organShortName: "",
        youthShortName: "",
        youthUuid: "",
        idName: "",
        // phone: '',
        idNumber: "",
        idType: "IDNUMBER",
        idCountry: "CN",
        headImgUrl: "",
        playerNumber: "",
        positionId: "",
        squadUuid: "",
        squadShortName: "",
        position: [],
        playerToSquads: [
          {
            squadUuidForCoach: "", // 教练用冗余数据
            squadUuidForCoachShow: "", // 教练用冗余数据 编辑回显
            organUuid: "", // 管理单位
            youthUuid: "", // 单位
            squadUuid: "", // 球队
            position: [], // 位置
            positionId: [], // 位置id
            playerNumber: "", // 球衣号
          },
        ], //临时数据
      },
      playerOption: [],
      addBtnLoading: false,
      userRole: storage.get("userInfo").userRole,
      uuid: storage.get("userInfo").uuid,
      organList: [],
      centerList: [],
      squadList: [],
      selectsquadList: [],
      editableList: [],
      id_numberMsg: '请输入身份证号',
    };
  },
  computed: {
    isShow: {
      get() {
        return this.addPlayer;
      },
      set(val) {
        this.$emit("update:addPlayer", val);
      },
    },
  },

  filters: {
    filterForRules(row) {
      // 注意位置必填规则应根据用户登录角色做区分；（教练员和其他角色存在不同的参数设置）
      const userRole = storage.get("userInfo").userRole;
      if (userRole !== "coach") {
        if (row.squadUuid) {
          return [requiredItem("位置")];
        } else {
          return [];
        }
      } else {
        if (row.squadUuidForCoach) {
          return [requiredItem("位置")];
        } else {
          return [];
        }
      }
    },
  },
  created() {
    this.getAllPositionList();
    if (this.userRole !== "coach") {
      this.getOrganListAndCenterList();
    } else {
      this.getSquadList();
    }
  },

  methods: {
    async setPlayerInfoInEditForCoach() {
      try {
        const { uuid } = this.player;
        const res = await player.getPlayerSquadList(uuid);

        // 没看懂这里要干嘛 //这个大聪明在data里面定义rules。。。真的优秀
        this.formRules.idNumberPass = this.player.idNumber;
        this.formRules.userUuid = this.player.uuid;
        this.validate_idnumber = this.player.idNumber;
        this.validate_user_uuid = this.player.uuid;
        if (res.code) {
          this.$message.error(res.msg);
          return;
        }
        let playerToSquads = res.map((item, index) => {
          const {
            squadUuid,
            youthUuid,
            organUuid,
            organShortName,
            youthShortName,
            shortName,
            position,
            positionId,
            playerNumber,
          } = item;
          const squadUuidForCoach = JSON.stringify({
            squadUuid,
            youthUuid,
            organUuid,
            organShortName,
            youthShortName,
            shortName,
          }); // 教练用冗余数据
          const squadUuidForCoachShow = shortName
            ? `${organShortName} ${youthShortName} ${shortName}`
            : `${organShortName} ${youthShortName}`;
          // this.changeSquadForCoach(squadUuidForCoach, index);
          return {
            squadUuidForCoach,
            squadUuidForCoachShow,
            organUuid, // 管理单位
            youthUuid, // 单位
            squadUuid, // 球队
            position: position && position.length ? position.split(",") : [], // 位置
            positionId:
              positionId && positionId.length ? positionId.split(",") : [], // 位置id
            playerNumber, // 球衣号
            canEdit: true,
          };
        });
        const avaibleSquadList = [];
        this.selectsquadList.forEach((item) => {
          avaibleSquadList.push(item.value);
        });
        playerToSquads.forEach((item, index) => {
          if (avaibleSquadList.includes(item.squadUuid)) {
            item.canEdit = false;
            this.changeOrg(item.organUuid, index);
            this.changeCenter(item.youthUuid, index);
            this.changeSquad(item.squadUuid, index);
          } else {
            item.canEdit = true;
          }
        });
        this.playerInfo = Object.assign({},this.playerInfo, this.player, {
          password: "",
          confirmPassword: "",
          headImgUrl: "",
          playerToSquads,
        });

        console.log('this.palyerInfo', this.playerInfo)
      } catch (err) {
        console.error("err", err);
      }
    },

    async setPlayerInfoInEditForSystem() {
      try {
        const { uuid } = this.player;
        const res = await player.getPlayerSquadList(uuid);
        this.formRules.idNumberPass = this.player.idNumber;
        this.formRules.userUuid = this.player.uuid;
        this.validate_idnumber = this.player.idNumber;
        this.validate_user_uuid = this.player.uuid;
        if (res.code) {
          this.$message.error(res.msg);
          return;
        }

        let playerToSquads = res.map((item, index) => {
          const {
            squadUuid,
            youthUuid,
            organUuid,
            organShortName,
            youthShortName,
            shortName,
            position,
            positionId,
            playerNumber,
          } = item;
          const squadUuidForCoach = JSON.stringify({
            squadUuid,
            youthUuid,
            organUuid,
            organShortName,
            youthShortName,
            shortName,
          }); // 教练用冗余数据
          // this.changeSquadForCoach(squadUuidForCoach, index);
          return {
            squadUuidForCoach,
            organUuid, // 管理单位
            organShortName,
            youthUuid, // 单位
            youthShortName,
            squadUuid: squadUuid ? squadUuid : "", // 球队
            shortName,
            position: position && position.length ? position.split(",") : [], // 位置
            positionId:
              positionId && positionId.length ? positionId.split(",") : [], // 位置id
            playerNumber, // 球衣号
            canEdit: true, // false允许登录用户编辑该球员的本条球队信息；
          };
        });
        let editableList = [];
        if (this.userRole === "system" || this.userRole === "admin") {
          // 系统管理员存在多个org
          this.organList.forEach((item) => {
            editableList.push(item.organUuid);
          });
        } else if (this.userRole === "organ") {
          // 协会这里只存在一个org
          this.organList.forEach((item) => {
            editableList.push(item.organUuid);
          });
        } else if (
          this.userRole === "youth" ||
          this.userRole === "club" ||
          this.userRole === "trainCamp"
        ) {
          // 这里青训中心等角色，只有一个管理单位（org），一个单位(seq), 多个球队
          const { youthList } = this.organList[0];
          youthList.forEach((item) => {
            editableList.push(item.uuid);
          });
        }
        this.editableList = editableList;
        playerToSquads.forEach((item, index) => {
          if (this.userRole === "system" || this.userRole === "admin") {
            // 系统管理员允许编辑所有球队信息
            item.canEdit = false;
            this.changeOrg(item.organUuid, index);
            this.changeCenter(item.youthUuid, index);
            this.changeSquad(item.squadUuid, index);
          } else if (this.userRole === "organ") {
            // 协会这里只存在一个org
            if (editableList.includes(item.organUuid)) {
              item.canEdit = false;
              this.changeOrg(item.organUuid, index);
              this.changeCenter(item.youthUuid, index);
              this.changeSquad(item.squadUuid, index);
            } else {
              item.canEdit = true; // 球员所属的协会非登录协会
            }
          } else if (
            this.userRole === "youth" ||
            this.userRole === "club" ||
            this.userRole === "trainCamp"
          ) {
            // 这里青训中心等角色，只有一个管理单位（org），一个单位(seq), 多个球队
            if (editableList.includes(item.youthUuid)) {
              item.canEdit = false;
              this.changeOrg(item.organUuid, index);
              this.changeCenter(item.youthUuid, index);
              this.changeSquad(item.squadUuid, index);
            } else {
              item.canEdit = true; // 球员所属的协会非登录协会
            }
          }
        });

        this.playerInfo = Object.assign({},this.playerInfo, this.player, {
          password: "",
          confirmPassword: "",
          headImgUrl: "",
          playerToSquads,
        });
        console.log('player', this.player)
        console.log('this.playerInfo', this.playerInfo)
      } catch (err) {
        console.error("err", err);
      }
    },

    getAllPositionList() {
      player.allPositionList().then((res) => {
        this.playerOption = res;
      });
    },
    getOrganListAndCenterList() {
      let data = this.uuid;
      let request;
      if (this.userRole === "organ") {
        request = squad.getOrgListByOrgan;
      } else if (this.userRole === "system" || this.userRole === "admin") {
        request = squad.getOrgListBySystem;
        data = "";
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        request = squad.getOrgListByYouth;
      } else if (this.userRole === "leader" || this.userRole === "coach") {
        request = squad.getOrgListByCoachOrLeader;
      }
      request(data).then((res) => {
        this.organList = res;
        if (this.organList.length == 1) {
          this.playerInfo.playerToSquads[0].organUuid =
            this.organList[0].organUuid;
          this.changeOrg(this.organList[0].organUuid, 0, true);
          if (this.centerList.length == 1) {
            this.playerInfo.playerToSquads[0].youthUuid =
              this.centerList[0][0].uuid;
            this.changeCenter(this.centerList[0][0].uuid, 0, true);
            if (this.squadList[0].length == 1) {
              this.playerInfo.playerToSquads[0].squadUuid =
                this.squadList[0][0].uuid;
              this.changeSquad(this.squadList[0][0].uuid, 0, true);
            }
          }
        }
        console.log('this.isEdit', this.isEdit)
        if (this.isEdit) {
          this.setPlayerInfoInEditForSystem();
        }
      });
    },

    getSquadList() {
      const _ = require("lodash");
      squad
        .getSquadListCoachAll()
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          const uni_selectYouthList = _.unionBy(res, "squadUuid");
          this.selectsquadList = uni_selectYouthList.map((item) => ({
            label: `${item.organShortName} - ${item.youthShortName} - ${item.shortName}`,
            value: item.squadUuid,
            key: JSON.stringify({
              squadUuid: item.squadUuid,
              youthUuid: item.youthUuid,
              organUuid: item.organUuid,
              organShortName: item.organShortName,
              youthShortName: item.youthShortName,
              shortName: item.shortName,
            }),
          }));
          if (this.selectsquadList.length === 1) {
            const defaultSquadUuidForCoach = this.selectsquadList[0].key;
            this.playerInfo.playerToSquads[0].squadUuidForCoach =
              defaultSquadUuidForCoach;
            this.changeSquadForCoach(defaultSquadUuidForCoach, 0);
          }

          if (this.isEdit) {
            this.setPlayerInfoInEditForCoach();
          }
        })
        .catch((err) => {
          console.error("err", err);
        });
    },
    changeOrg(val, index, canClear) {
      !canClear ? (canClear = true) : (canClear = false);
      if (canClear && this.playerInfo.playerToSquads[index]) {
        this.playerInfo.playerToSquads[index].youthUuid = "";
        this.playerInfo.playerToSquads[index].youthShortName = "";
        this.playerInfo.playerToSquads[index].squadUuid = "";
        this.playerInfo.playerToSquads[index].squadShortName = "";
      }
      if (val) {
        if (this.organList && this.organList.length) {
          const findData = this.organList.find((item) => {
            return item.organUuid === val;
          });
          findData !== "undefined"
            ? (this.centerList[index] = findData.youthList)
            : (this.centerList[index] = []);
        }
      } else {
        this.centerList = [];
      }
    },
    changeCenter(val, index, canClear) {
      !canClear ? (canClear = true) : (canClear = false);
      if (canClear && this.playerInfo.playerToSquads[index]) {
        this.playerInfo.playerToSquads[index].squadUuid = "";
        this.playerInfo.playerToSquads[index].squadShortName = "";
      }
      if (val) {
        if (this.centerList[index] && this.centerList[index].length) {
          const findDataForSquadList = this.centerList[index].find((item) => {
            return item.uuid === val;
          });
          this.squadList[index] = findDataForSquadList.squadList || [];
        }
      } else {
        this.squadList[index] = [];
      }
    },
    changeSquad(val, index, canClear) {
      !canClear ? (canClear = true) : (canClear = false);
      if (canClear && this.playerInfo.playerToSquads[index]) {
        this.playerInfo.playerToSquads[index].duty &&
          (this.playerInfo.playerToSquads[index].duty = "");
        this.playerInfo.playerToSquads[index].coachNature &&
          (this.playerInfo.playerToSquads[index].coachNature = "");
      }
    },
    changeSquadForCoach(val, index) {
      if (val) {
        const selectSquad = JSON.parse(val);
        let { playerToSquads } = this.playerInfo;
        const {
          organShortName,
          organUuid,
          shortName,
          squadUuid,
          youthShortName,
          youthUuid,
        } = JSON.parse(val);
        playerToSquads[index].organShortName = organShortName;
        playerToSquads[index].organUuid = organUuid;
        playerToSquads[index].shortName = shortName;
        playerToSquads[index].squadUuid = squadUuid;
        playerToSquads[index].youthShortName = youthShortName;
        playerToSquads[index].youthUuid = youthUuid;
      }
    },
    addPlayerAccount() {
      this.$refs["playerInfo"].validate(async (vali) => {
        if (vali) {
          let { playerToSquads } = this.playerInfo;
          playerToSquads = playerToSquads.map((item) => {
            const { position, positionId, ...rest } = item;
            return {
              ...rest,
              position: position && position.length ? position.join(",") : "",
              positionId:
                positionId && positionId.length ? positionId.join(",") : "",
            };
          });
          this.addBtnLoading = true;
          let requestName = player.addPlayer;
          let requestData = {
            player: {
              squadUuid: this.playerInfo.squadUuid,
              position: "",
              // positionId: this.playerInfo.positionId.join(','),
              // playerNumber: this.playerInfo.playerNumber,
              organUuid: this.playerInfo.organUuid,
              youthUuid: this.playerInfo.youthUuid,
              organShortName: this.playerInfo.organShortName,
              youthShortName: this.playerInfo.youthShortName,
              shortName: this.playerInfo.squadShortName,
            },
            playerToSquads: playerToSquads,
            userForm: {
              idName: this.playerInfo.idName,
              idNumber: this.playerInfo.idNumber,
              // phone: this.playerInfo.phone,
              headImgUrl: this.playerInfo.headImgUrl,
              idType: this.playerInfo.idType,
              idCountry: this.playerInfo.idCountry,
              birthday: this.playerInfo.birthday,
              gender: this.playerInfo.gender,
            },
          };
          if (this.isEdit) {
            requestName = player.updatePlayer;
            requestData.player.uuid = this.playerInfo.uuid;
            if (this.playerInfo.password) {
              let username = this.playerInfo.idNumber;
              // // ras 加密
              let publicKey = await auth.getPublicKey(username);
              let encryptor = new JSEncrypt();
              encryptor.setPublicKey(publicKey);
              let rsaPassword = encryptor.encrypt(this.playerInfo.password);
              requestData.userForm.password = rsaPassword;
            }
          }

          console.log('requestData', requestData)
          requestName(requestData)
            .then((res) => {
              this.addBtnLoading = false;
              if (res.code) {
                this.$message.error(res.msg);
              } else {
                this.$emit("hideDialog", false);
              }
            })
            .catch((err) => {
              this.addBtnLoading = false;
              console.error(err);
            });
        }
      });
    },
    changePosition(val, index) {
      if (val.length) {
        let arr = [];
        val.forEach((item) => {
          this.playerOption.some((positionInfo) => {
            if (item === positionInfo.playerPositionName) {
              arr.push(positionInfo.id);
            }
          });
        });
        const { playerToSquads } = this.playerInfo;
        playerToSquads[index].positionId = arr;
        this.$set(this.playerInfo, "playerToSquads", playerToSquads);
      } else {
        const { playerToSquads } = this.playerInfo;
        playerToSquads.positionId = [];
        this.$set(this.playerInfo, "playerToSquads", playerToSquads);
      }
    },
    handleDeletePlayerList(index) {
      let { playerToSquads } = this.playerInfo;
      playerToSquads.splice(index, 1);
      if (playerToSquads.length > 0) {
        playerToSquads.forEach((playerItem, playerIndex) => {
          // this.changeOrg(playerItem.organUuid, playerIndex, true); // 模拟协会切换
          // this.changeCenter(playerItem.youthUuid, playerIndex, true); // 模拟单位切换
          // this.changeSquad(playerItem.squadUuid, playerIndex, true); // 模拟球队切换
          const editableList = this.editableList;
          if (this.userRole === "system" || this.userRole === "admin") {
            // 系统管理员允许编辑所有球队信息
            playerItem.canEdit = false;
            this.changeOrg(playerItem.organUuid, playerIndex, true);
            this.changeCenter(playerItem.youthUuid, playerIndex, true);
            this.changeSquad(playerItem.squadUuid, playerIndex, true);
          } else if (this.userRole === "organ") {
            // 协会这里只存在一个org
            if (editableList.includes(playerItem.organUuid)) {
              playerItem.canEdit = false;
              this.changeOrg(playerItem.organUuid, playerIndex, true);
              this.changeCenter(playerItem.youthUuid, playerIndex, true);
              this.changeSquad(playerItem.squadUuid, playerIndex, true);
            } else {
              playerItem.canEdit = true; // 球员所属的协会非登录协会
            }
          } else if (
            this.userRole === "youth" ||
            this.userRole === "club" ||
            this.userRole === "trainCamp"
          ) {
            // 这里青训中心等角色，只有一个管理单位（org），一个单位(seq), 多个球队
            if (editableList.includes(playerItem.youthUuid)) {
              playerItem.canEdit = false;
              this.changeOrg(playerItem.organUuid, playerIndex, true);
              this.changeCenter(playerItem.youthUuid, playerIndex, true);
              this.changeSquad(playerItem.squadUuid, playerIndex, true);
            } else {
              playerItem.canEdit = true; // 球员所属的协会非登录协会
            }
          }
        });
      }
      this.$set(this.playerInfo, "playerToSquads", playerToSquads);
    },
    handleAddPlayerList() {
      let { playerToSquads } = this.playerInfo;
      playerToSquads.push({
        organUuid: "",
        youthUuid: "",
        squadUuid: "",
        squadUuidForCoach: "",
        position: [], // 位置
        positionId: [], // 位置id
        playerNumber: "", // 球衣号
        canEdit: false,
      });
      this.$set(this.playerInfo, "playerToSquads", playerToSquads);
    },

    changeType(val) {
      switch (this.playerInfo.idType) {
        case "IDNUMBER": // 身份证
          this.playerInfo.idCountry = "CN";
          this.id_numberMsg = "请输入身份证号";
          break;
        case "IDTYPECODEWGJZZ": // 外国人永久居留身份证
          this.playerInfo.idCountry = "CN";
          this.id_numberMsg = "例如：CAN000000000000";
          break;
        case "IDTYPECODEHMT": // 港澳台居民居住证
          this.playerInfo.idCountry = "CN";
          this.id_numberMsg = "请输入港澳台居民居住证号";
          break;
        case "HM": // 港澳居民来往内地通行证
          this.playerInfo.idCountry = "CN";
          this.id_numberMsg = "例如：H00000000";
          break;
        case "TAI": // 台湾居民来往大陆通行证
          this.playerInfo.idCountry = "CN";
          this.id_numberMsg = "例如：00000000";
          break;
        case "PASSPORT": // 护照（非中国大陆人员）
          this.playerInfo.idCountry = "";
          this.id_numberMsg = "例如：E00000000";
          break;
      }
    },
  },
};
</script>

<style scoped lang="stylus">
.demo-ruleForm
  height 500px
.tip
  margin-top 10px
  color red
  width 100%
  text-align center
  word-break break-word
.player-list-wrapper
  width 95%
  display flex
  justify-content space-around
  border-bottom 1px dashed #ccc
  border-top 1px dashed #ccc
  padding 20px 20px 0px 0px
  margin-bottom 20px
  .left-box
    width 100%
  .right-box
    width 40px
    display flex
    justify-content center
    flex-direction column
    align-items center
</style>
